<template>
    <div class="input" v-if="map.actions.match(opt, editorElement)" :iscollapsible="!!opt.expand">

      <div v-if="opt.expand" class="expand" v-b-toggle="`fw-bs-expand-`+opt.name">&#9654;</div>


      <b-input-group v-if="opt.type===map.TYPE_INPUT" class="mt-2" size="sm" :prepend="opt.label" :append="opt.append">
        <b-form-input
          :id="`fw-bs-`+opt.name"
          type="text"
          size="sm"
          :value="getValue"
          v-on:change="getChangeListener(editorElement, opt, $event)"
        >
        </b-form-input>
      </b-input-group>

        <b-input-group v-if="opt.type===map.TYPE_INPUT_NUMBER" class="mt-2" size="sm" :prepend="opt.label" :append="opt.append">
          <b-form-input
            :id="`fw-bs-`+opt.name"
            type="number"
            size="sm"
            :value="getValue"
            v-on:change="getChangeListener(editorElement, opt, $event)"
          >
          </b-form-input>
        </b-input-group>

        <b-form-group v-if="opt.type===map.TYPE_TEXTAREA" class="mt-2" label-size="sm" :label="opt.label+':'">
          <codemirror
            :value="getValue"
            :options="cmTemplateOptions"
            :name="`fw-bs-`+opt.name"
            class="optionsMapTextArea"
            @input="getChangeListener(editorElement, opt, $event)"
          />
        </b-form-group>

        <b-input-group class="mt-2" v-if="opt.type===map.TYPE_SELECT" size="sm" :prepend="opt.label">
          <b-form-select
            variant="success"
            size="sm"
            :name="`fw-bs-`+opt.name"
            :value="getValue"
            :options="opt.options"
            @change="getChangeListener(editorElement, opt, $event)"
          ></b-form-select>
        </b-input-group>


      <b-input-group class="mt-2" v-if="opt.type===map.TYPE_CHECKBOX_GROUP" size="sm" :prepend="opt.label">
        <b-form-checkbox-group
          button-variant="outline-primary"
          buttons
          size="sm"
          :id="`fw-bs-`+opt.name"
          :name="`fw-bs-`+opt.name"
          :key="`fw-bs-`+opt.name"
          :options="opt.options"
          :checked="getValue"
          @change="getChangeListener(editorElement, opt, $event)"
        ></b-form-checkbox-group>
      </b-input-group>


        <b-input-group class="mt-2" v-if="opt.type===map.TYPE_RADIO_GROUP" size="sm" :prepend="opt.label">
          <b-form-radio-group
            button-variant="outline-primary"
            buttons
            size="sm"
            :id="`fw-bs-`+opt.name"
            :name="`fw-bs-`+opt.name"
            :key="`fw-bs-`+opt.name"
            :options="opt.options"
            :checked="getValue"
            @change="getChangeListener(editorElement, opt, $event)"
          ></b-form-radio-group>
        </b-input-group>


        <b-form-checkbox
          switch
          class="ml-2 mt-2"
          v-if="opt.type===map.TYPE_CHECKBOX"
          :name="`fw-bs-`+opt.name"
          :key="`fw-bs-`+opt.name"
          :checked="getChecked"
          v-on:change="getChangeListener(editorElement, opt, $event)" >{{opt.label===null?'empty':opt.label}}</b-form-checkbox>

        <b-input-group class="mt-2" v-if="opt.type===map.TYPE_COLOR_PICKER" size="sm" :prepend="opt.label">
          <el-color-picker class="form-control form-control-sm py-0 pr-1 text-right"
            :value="getValue" size="mini"
            @change="getChangeListener(editorElement, opt, $event)"
          ></el-color-picker>
        </b-input-group>
        <div v-if="opt.type===map.TYPE_COLOR_PICKER" :style="{background: getValue}">
        </div>

        <div v-if="opt.expand">
          <b-collapse :id="`fw-bs-expand-`+opt.name">
            <div v-for="childOpt in opt.expand">

              <options-map-input
                :opt="childOpt"
                :editor-element="editorElement"
                :updateTemplate="updateTemplate"
              ></options-map-input>

            </div>
          </b-collapse>
        </div>


    </div>
</template>

<script>
  import optionsMap from '@/libs/frontwise-editor/optionsMap.js'
  // helpers
  import constants from '@/helpers/constants'
  import colorPicker from '@caohenghu/vue-colorpicker'

  export default {
    name: 'optionsMapInput.vue',

    components: {
      colorPicker,
      optionsMapInput: () => import('./optionsMapInput.vue')
    },

    props: ['opt', 'editorElement', 'updateTemplate'],

    data() {
      return {
        map: optionsMap
      }
    },

    methods: {
      getChangeListener(editorElement, opt, $event) {
        return this.map.listeners.change(editorElement, opt, $event, this.updateTemplate)
      },
    },

    computed: {
      cmTemplateOptions() {
        return {
          ...constants.cmTemplateOptions,
          mode: "text/javascript",
          htmlMode: true
        }
      },
      getValue() {
        return this.map.actions.filter(this.opt, this.editorElement)
      },
      getChecked() {
        return !!this.editorElement.getAttribute(this.opt.target)
      }
    }
  }
</script>

<style scoped>
  .input-group-prepend>.input-group-text {
    min-width: 60px !important;
  }
  .input-group-sm {
    display: flex;
    flex-flow: row;
  }
  .input {
    position: relative;
  }
  .expand {
    position: absolute;
    margin-top: 10px;
    margin-left: 3px;
    z-index: 1;
    cursor: pointer;
    font-size: 12px;
    color: white;
    width: 10px;
    height: 10px;
    line-height: 11px;
    transition: transform 200ms;
    transform: rotateZ(90deg);
  }
  .expand.collapsed {
    transform: rotateZ(0);
  }
</style>
